import MegamenuNavigation from './megamenu-navigation';
import LayoutNavigationHelper from './layout-navigation-helper';

window.WartsilaMegamenuNavigation = MegamenuNavigation;
window.LayoutNavigationHelper = LayoutNavigationHelper;
